import React, {FC} from 'react';
import {ReactComponent as ArrayIcon} from '../../../../../../../assets/main/groups/main-table/array.svg';
import {NavLink} from "react-router-dom";
import {TestItem} from "features/model/types/test/TestSchema";
import {useAppDispatch} from "common/hook";
import {setActiveTabs} from "app/top-tabs-reduser";


interface TeacherTestItemsProps {
    test: TestItem;
}

export const TeacherTestItems: FC<TeacherTestItemsProps> = ({test}) => {

    const dispatch = useAppDispatch()

    const handleNavLinkClick = () => {
        dispatch(setActiveTabs([1]));
    };

    return (
        <div className="row">
            <div className="col test-col auto-width full-width-mobile">
                <span className="col-title">Тест</span>
                <p>
                    <NavLink to={`/test/${test.id}`}>{test.title}</NavLink> {" "}
                </p>
            </div>
            <div className="col group-col full-width-mobile">
                <span className="col-title">Автор</span>
                <p>
                   {test.author.name}{" "}
                </p>
            </div>
            <div className="col students-col">
                <span className="col-title">Студенты</span>
                <div className="students-number">
                    {test.users.items && test.users.items.length > 0 ? (
                        <>
                            {test.users.items.map((student,index) => (
                                <div className="avatar" key={index}>
                                    <img src={student.avatar} alt=""/>
                                </div>
                            ))}
                            {test && test.users && test.users.count && (
                                <span className="num">{test.users.count}</span>
                            )}
                        </>
                    ) : (
                        <span className="num">0</span>
                    )}
                </div>
            </div>

            <div className="col passed-test-col align-right">
                <span className="col-title">Прошли тест</span>
                <p>
                    <NavLink to={`/test/${test?.id}`} onClick={handleNavLinkClick}>
                        {test.passedTest}
                    </NavLink>
                </p>
            </div>


            <div className="col btn-link-col">
                         <span className="circle-arrow-btn">
                               <NavLink style={{boxShadow: 'none'}} to={`/test/${test.id}`}>
                                     <ArrayIcon/>
                               </NavLink>
                        </span>
            </div>

        </div>
    );
};


{/*<NavLink to={`/test/${test.id}`}>{test.author.name}</NavLink> {" "}*/}
{/*<a href="">{test.author.name}</a> {" "}*/}
{/*{test && test.group && test.group.count && (*/}
{/*    <span className="complited-count dark">+{test.group.count}</span>*/}
{/*)}*/}
